import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import fintorroLogo from '../assets/fintorro-logo.png'; // Ensure the logo is in the assets folder

const NavbarComponent = () => {
  return (
    <Navbar expand="lg" style={{ backgroundColor: '#232830', padding: '10px' }}>
      <Container>
        {/* Logo */}
        <Navbar.Brand as={Link} to="/">
          <img
            src={fintorroLogo}
            alt="Fintorro Logo"
            style={{
              height: '40px',
              marginRight: '10px',
              filter: 'drop-shadow(0px 0px 5px rgba(255,255,255,0.5))' // Light shadow for better visibility
            }}
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="navbar-nav" style={{ backgroundColor: '#FFFFFF' }} />
        <Navbar.Collapse id="navbar-nav">
          <Nav className="ms-auto">
            {/* <Nav.Link href="https://www.fintorro.com/learn" 
              style={{ color: '#FFFFFF', fontSize: '16px', fontWeight: '600' }}>
              Learn
            </Nav.Link> */}
            {/* <Nav.Link href="https://www.fintorro.com/magazine" 
              style={{ color: '#FFFFFF', fontSize: '16px', fontWeight: '600' }}>
              Magazine
            </Nav.Link>
            <Nav.Link href="https://www.fintorro.com/financialfreedom" 
              style={{ color: '#FFFFFF', fontSize: '16px', fontWeight: '600' }}>
              Financial Freedom
            </Nav.Link>
            <Nav.Link href="https://www.fintorro.com/challenges" 
              style={{ color: '#FFFFFF', fontSize: '16px', fontWeight: '600' }}>
              Challenges
            </Nav.Link> */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavbarComponent;
